import React from 'react';
import styled from "styled-components"
import {Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";

const StyledContainer = styled.div`
  width: 100%;
  height: 17rem;
  padding: 1rem;
  .reporting-date {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #4A4A4A;
    color: #4A4A4A;
  }
`

const ReportGraph = ({data}) => {
  return (
    <StyledContainer>
      <ResponsiveContainer width={'100%'} height={'100%'}>
        <AreaChart data={data}
                   margin={{ top: 10, right: 0, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorCurrentStatTwo" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#D1E6F3" stopOpacity={0.8}/>
              <stop offset="95%" stopColor="#D1E6F3" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <XAxis
            tickLine={false}
            axisLine={false}
            dataKey="date"
            hide={true}
          />
          <YAxis
            hide={true}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip />
          <Area type="monotone" dataKey="This Week" stroke="#0E7CBF" fillOpacity={1} fill="url(#colorCurrentStatTwo)" />
          <Area type="monotone" dataKey="Last Week" stroke="#7E7E7E" fillOpacity={1} fill="url(#colorPastStatTwo)" />
        </AreaChart>
      </ResponsiveContainer>
      <div className={'reporting-date'}>
        <div>July 13</div>
        <div>Today</div>
      </div>
    </StyledContainer>
  )
}

export default ReportGraph;